module.exports = __webpack_public_path__ + "img/akasaka.d853eebc.jpg";